<app-mission-strip></app-mission-strip>
<router-outlet></router-outlet>